import { render, staticRenderFns } from "./cognition.vue?vue&type=template&id=7b7b0a48"
import script from "./cognition.vue?vue&type=script&lang=js"
export * from "./cognition.vue?vue&type=script&lang=js"
import style0 from "./cognition.vue?vue&type=style&index=0&id=7b7b0a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports